"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Button = _interopRequireDefault(require("../Button"));
var _MobileGallery = _interopRequireDefault(require("../MobileGallery"));
var _userflow = require("../../utils/userflow");
var _excluded = ["description", "gallery", "isMobile", "onExpand", "title"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StyledCounter = _MobileGallery["default"].StyledCounter;
var HotelExperienceCard = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var description = _ref.description,
    gallery = _ref.gallery,
    isMobile = _ref.isMobile,
    onExpand = _ref.onExpand,
    title = _ref.title,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledHotelExperienceCard, (0, _extends2["default"])({
    isMobile: isMobile
  }, props), !(0, _isEmpty2["default"])(gallery) && /*#__PURE__*/_react["default"].createElement(StyledGalleryContainer, null, /*#__PURE__*/_react["default"].createElement(_MobileGallery["default"], {
    controls: !isMobile,
    counter: true,
    height: isMobile ? 260 : 300,
    images: gallery,
    width: isMobile ? 210 : 420
  })), /*#__PURE__*/_react["default"].createElement(StyledTitle, null, title), /*#__PURE__*/_react["default"].createElement(StyledDescription, null, description), /*#__PURE__*/_react["default"].createElement(StyledExpandButton, {
    $isMobile: isMobile,
    size: "none",
    onClick: onExpand
  }, "\u041F\u043E\u0447\u0438\u0442\u0430\u0442\u044C \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E"));
});
HotelExperienceCard.propTypes = {
  className: _propTypes["default"].string,
  description: _propTypes["default"].string,
  gallery: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    images: _propTypes["default"].shape((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _userflow.IMAGES_SIZE.SMALL, _propTypes["default"].string), _userflow.IMAGES_SIZE.FULL, _propTypes["default"].string), _userflow.IMAGES_SIZE.BIG, _propTypes["default"].string.isRequired), _userflow.IMAGES_SIZE.BIG_X2, _propTypes["default"].string)).isRequired,
    special: _propTypes["default"].shape({
      id: _propTypes["default"].number,
      content: _propTypes["default"].string,
      title: _propTypes["default"].string
    }).isRequired
  })),
  isMobile: _propTypes["default"].bool,
  onExpand: _propTypes["default"].func,
  title: _propTypes["default"].string.isRequired
};
HotelExperienceCard.defaultProps = {
  className: '',
  description: null,
  gallery: [],
  isMobile: false,
  onExpand: Function.prototype
};
var StyledGalleryContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelExperienceCard__StyledGalleryContainer",
  componentId: "sc-1n3vg0e-0"
})(["width:100%;border-radius:6px;margin-bottom:12px;overflow:hidden;"]);
var StyledTitle = _styledComponents["default"].span.withConfig({
  displayName: "HotelExperienceCard__StyledTitle",
  componentId: "sc-1n3vg0e-1"
})(["margin-right:7px;"]);
var StyledDescription = _styledComponents["default"].div.withConfig({
  displayName: "HotelExperienceCard__StyledDescription",
  componentId: "sc-1n3vg0e-2"
})(["margin-bottom:16px;margin-top:7px;text-align:left;white-space:normal;"]);
var StyledExpandButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "HotelExperienceCard__StyledExpandButton",
  componentId: "sc-1n3vg0e-3"
})(["padding:12px 16px;margin-bottom:2px;--background-color:", ";background-color:var(--background-color);border-radius:var(--border-radius);:hover{background:linear-gradient(0deg,rgba(0,0,0,var(--hover-alpha)) 0%,rgba(0,0,0,var(--hover-alpha)) 100%),var(--background-color);}:active{background:linear-gradient(0deg,rgba(0,0,0,var(--pressed-alpha)) 0%,rgba(0,0,0,var(--pressed-alpha)) 100%),var(--background-color);}"], function (_ref2) {
  var $isMobile = _ref2.$isMobile;
  return $isMobile ? 'var(--background)' : 'var(--white)';
});
var StyledHotelExperienceCard = _styledComponents["default"].div.withConfig({
  displayName: "HotelExperienceCard__StyledHotelExperienceCard",
  componentId: "sc-1n3vg0e-4"
})(["", ""], function (_ref3) {
  var theme = _ref3.theme,
    isMobile = _ref3.isMobile;
  return (0, _styledComponents.css)(["width:", "px;animation:fade 400ms ease;", "{color:var(--black);font-size:18px;font-style:normal;font-weight:500;", "}", "{color:var(--black);font-size:14px;font-style:normal;font-weight:400;}", "{color:var(--black) font-size:14px;font-style:normal;font-weight:400;}", "{bottom:", "px;right:", "px;}&[data-hidden=\"true\"]{display:none;}@keyframes fade{from{opacity:0;}}"], isMobile ? 210 : 420, StyledTitle, function (_ref4) {
    var $isMobile = _ref4.$isMobile;
    return $isMobile && (0, _styledComponents.css)(["font-size:14px;"]);
  }, StyledDescription, StyledExpandButton, StyledCounter, isMobile ? 9 : 16, isMobile ? 8 : 12);
});
var _default = exports["default"] = HotelExperienceCard;